import { useEffect, useState } from "react";
import { fetchOptaEvents } from "../dds/optaEvents";

/**
 * One fixture's raw Opta events while `wanted` is true, else null (OPUS-1615).
 * `fields` limits each event to the fields the caption listed.
 * Fetched once each time `wanted` turns on, so every open of the Touch Map is
 * fresh but the caption window's repeated getContext calls (one per DDS patch,
 * one per send) never refetch.
 */
export function useOptaEvents({ wanted, fields, competitionId, seasonId, fixtureId }) {
  const [optaEvents, setOptaEvents] = useState(null);
  // A key, not the array: a new array with the same fields must not refetch.
  const fieldsKey = fields?.join(",") ?? "";

  useEffect(() => {
    setOptaEvents(null);
    if (!wanted || !fixtureId) return undefined;
    let cancelled = false;
    fetchOptaEvents({ competitionId, seasonId, fixtureId, fields: fieldsKey ? fieldsKey.split(",") : undefined })
      .then((events) => {
        if (!cancelled) setOptaEvents(events);
      })
      .catch((err) => console.warn("[OptaEvents] fetch failed", err));
    return () => {
      cancelled = true;
    };
  }, [wanted, fieldsKey, competitionId, seasonId, fixtureId]);

  return optaEvents;
}
